import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=19d040d9&"
import script from "./Container.vue?vue&type=script&lang=js&"
export * from "./Container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d040d9')) {
      api.createRecord('19d040d9', component.options)
    } else {
      api.reload('19d040d9', component.options)
    }
    module.hot.accept("./Container.vue?vue&type=template&id=19d040d9&", function () {
      api.rerender('19d040d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/peach-pear-plum/components/Container.vue"
export default component.exports